import React, { useState } from 'react';
import Loader from './Loader';

const ProductCard = ({ tshirt, onSelect, selectedColorIndex = 0 }) => {
  const [currentSelectedColor, setCurrentSelectedColor] = useState(selectedColorIndex || 0);

  const getColorStyle = (colorName) => {
    const colorMap = {
      'Negro': 'bg-black',
      'Beige': 'bg-amber-100',
      'Blanco': 'bg-white border border-gray-300',
      'Gris': 'bg-gray-500', 
      'Azul': 'bg-blue-600',
      'Verde': 'bg-green-600',
      'Verde Militar': 'bg-green-800',
      'Blanco con Azul': 'bg-gradient-to-br from-white to-blue-500 border border-gray-300',
      'Blanco con Negro': 'bg-gradient-to-br from-white to-black border border-gray-300',
      'Negro con Blanco': 'bg-gradient-to-br from-black to-white border border-gray-300',
      'Negro con Azul': 'bg-gradient-to-br from-black to-blue-900',
      'Navy': 'bg-blue-900',
      'Chocolate': 'bg-amber-900'
    };
    
    return colorMap[colorName] || 'bg-gray-200';
  };

  const getImageToShow = () => {
    if (!tshirt || !tshirt.colors || tshirt.colors.length === 0) return '';
    const color = tshirt.colors[currentSelectedColor] || tshirt.colors[0];
    if (!color) return '';
    
    // Mostrar frontal solo para Plain y Overthinking
    if (tshirt.name === "Plain t-shirt" || tshirt.name === "Plain hoodie" || tshirt.name === "Overthinking") {
      return color.frontImage || color.backImage || tshirt.colors[0].frontImage || tshirt.colors[0].backImage || '';
    }
    // Para los demás, mostrar trasera por defecto, con fallback a frontal
    return color.backImage || color.frontImage || tshirt.colors[0].backImage || tshirt.colors[0].frontImage || '';
  };

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const [imageLoading, setImageLoading] = useState(true);

  if (!tshirt) return <div className="bg-gray-200 rounded-lg">Cargando...</div>;

  return (
    <div 
      className="cursor-pointer group bg-white rounded-lg md:rounded-xl overflow-hidden"
      onClick={() => onSelect(tshirt, tshirt.colors[currentSelectedColor].name || tshirt.colors[0].name)}
    >
      <div className="relative h-72 md:h-96 overflow-hidden">
        {imageLoading && <Loader />}
        <img 
          src={getImageToShow()}
          alt={tshirt.name} 
          className={`w-full h-full object-contain group-hover:scale-105 transition-transform duration-300 ${imageLoading ? 'hidden' : ''}`}
          onLoad={handleImageLoad}
          onError={handleImageLoad}
        />
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-base md:text-lg font-bold">{tshirt.name}</h3>
        <div className="flex justify-between items-center mt-2 md:mt-3">
          <p className="text-base md:text-lg font-bold">${tshirt.price.toFixed(2)} USD</p>
          <div className="flex space-x-2">
            {tshirt.colors && tshirt.colors.map((color, index) => (
              <button
                key={index}
                className={`w-5 h-5 rounded-full ${currentSelectedColor === index ? 'ring-2 ring-black' : ''} ${getColorStyle(color.name)}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentSelectedColor(index);
                  setImageLoading(true);
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;